import { Fragment } from 'react'
import bg from 'assets/img/research/university-columbia.jpg'
import dodstem from "assets/img/common/dow-stem.png";

export const banner = {
  bg: bg,
  heading: (
    <Fragment>
      <span className="d-block mb-5 ds-research-title">
        National Data Science Research
      </span>
      <small className="d-block">Oceanside Scholars Program</small>
    </Fragment>
  ),
  subHeading: 'Develop data science skills | Conduct cutting-edge research using real-world data | Increase college competitiveness |',
  description: (
    <Fragment>
      <span className='fs-20 d-block'>Incoming 9<sup>th</sup> &mdash; 12<sup>th</sup> graders and rising college freshmen</span>
      <span className='fs-20 d-block'>July 7 - August 8, 2025</span>
      <span className='fs-20 d-block mt-20'>Oceanside Scholars Program is open to students in the Oceanside, California area</span>
    </Fragment>
  ),
  links: [
    {
      linkText: 'Apply',
      link: 'https://form.jotform.com/250126051228142',
      isExternal: true,
    },
  ],
}
